export default function () {
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-drawer__overlay');
  const allCarts = document.querySelectorAll('.shop__sub-header-cart');
  const openButtons = allCarts ? Array.from(allCarts) : [];
  const allCartsDrawerClose = drawer?.querySelectorAll('.cart-drawer__close');
  const closeButtons = allCartsDrawerClose ? Array.from(allCartsDrawerClose) : [];
  if (!drawer || !overlay || openButtons.length === 0) return;

  let lastFocused = null;
  let previousBodyOverflow = '';
  let isOpen = false;

  const getFocusable = (container) => Array
    .from(container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])',
    ))
    .filter((el) => el.offsetWidth || el.offsetHeight || el.getClientRects().length);

  function openDrawer(triggerEl = null) {
    if (isOpen) return;
    isOpen = true;
    lastFocused = triggerEl || document.activeElement;

    overlay.removeAttribute('hidden');
    drawer.removeAttribute('hidden');

    requestAnimationFrame(() => {
      drawer.classList.add('open');
      overlay.classList.add('open');
    });

    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // eslint-disable-next-line no-use-before-define
    document.addEventListener('keydown', onKeyDown);
    // eslint-disable-next-line no-use-before-define
    overlay.addEventListener('click', onOverlayClick);
    // eslint-disable-next-line no-use-before-define
    document.addEventListener('focusin', keepFocusInside);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    drawer.classList.remove('open');
    overlay.classList.remove('open');

    document.body.style.overflow = previousBodyOverflow || '';

    const onTransitionEnd = (e) => {
      if (e.target === drawer && e.propertyName === 'transform') {
        drawer.setAttribute('hidden', '');
        overlay.setAttribute('hidden', '');
        drawer.removeEventListener('transitionend', onTransitionEnd);
      }
    };
    drawer.addEventListener('transitionend', onTransitionEnd);
    setTimeout(() => {
      if (!drawer.classList.contains('open')) {
        drawer.setAttribute('hidden', '');
        overlay.setAttribute('hidden', '');
      }
    }, 400);

    // eslint-disable-next-line no-use-before-define
    document.removeEventListener('keydown', onKeyDown);
    // eslint-disable-next-line no-use-before-define
    overlay.removeEventListener('click', onOverlayClick);
    // eslint-disable-next-line no-use-before-define
    document.removeEventListener('focusin', keepFocusInside);

    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function onKeyDown(e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      const focusable = getFocusable(drawer);
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function onOverlayClick(e) {
    if (e.target === overlay) closeDrawer();
  }

  function keepFocusInside(e) {
    if (!isOpen) return;
    if (drawer.contains(e.target)) return;
    const focusable = getFocusable(drawer);
    if (focusable.length) focusable[0].focus();
    else drawer.focus();
  }

  openButtons.forEach((btn) => btn.addEventListener('click', (ev) => {
    ev.preventDefault();
    openDrawer(btn);
  }));
  closeButtons.forEach((btn) => btn.addEventListener('click', (ev) => {
    ev.preventDefault();
    closeDrawer();
  }));

  const checkout = drawer.querySelector('.cart-drawer__actions a[href]');
  if (checkout) {
    checkout.addEventListener('click', () => {
      closeDrawer();
    });
  }

  if (!drawer.hasAttribute('hidden') && !drawer.classList.contains('open')) {
    drawer.setAttribute('hidden', '');
  }
  if (!overlay.hasAttribute('hidden') && !overlay.classList.contains('open')) {
    overlay.setAttribute('hidden', '');
  }
}
